import store from '../store'

export const nowServerTime = (): number => {
  const serverTimeDelta = store.getState().server.timeDelta
  return Date.now() + serverTimeDelta
}
